module.exports = __webpack_public_path__ + "static/media/air-sc.de8c7dd4.svg";